<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header data-background-color="secondary">
            <h4 class="title">Sydney Markets Induction</h4>
          </md-card-header>
          <md-card-content>
            <induction-form />
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import InductionForm from "../Forms/InductionForm.vue";
export default {
  components: {
    InductionForm
  }
};
</script>
